import { useCallback, useEffect } from "react";

import { ResponseHandler } from "@king-ict/eupisi-ui/components";
import { useKeycloak } from "@king-ict/eupisi-ui/hooks";
import { useDispatch } from "react-redux";

import { login } from "../api";
import { adminWebUserPortalAplicationUrl } from "../app";
import { Layout } from "../components";
import { useAuthorization } from "../hooks";
import { getUser, getImportantDate, getPedagogicalYear, getInstitutionDetails } from "../slices";
import "../../public/css/calendar.css";

export const App = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();

  const { isAuthorized } = useAuthorization(false);

  useEffect(() => {    
    if (keycloak.authenticated) {
      login()
        .then(() => {
          dispatch(getUser());
          dispatch(getImportantDate());
          dispatch(getPedagogicalYear());
          dispatch(getInstitutionDetails());
        });
    };
  }, [dispatch, isAuthorized, keycloak.authenticated]);

  if (!keycloak.authenticated) {
    window.location.href = `${adminWebUserPortalAplicationUrl}`;
  };

  const setImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-vision-impaired");
    document.documentElement.classList.remove("theme-default");
  }, []);

  const removeImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-default");
    document.documentElement.classList.remove("theme-vision-impaired");
  }, []);

  return (
    <Layout
        setImpairedStyle={setImpairedStyle}
        removeImpairedStyle={removeImpairedStyle}
      >
      <ResponseHandler />
    </Layout>
  );
};

